import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LEFT } from '@instructure/quiz-common';
var generateStyle = function generateStyle(componentTheme, props) {
  var mp = '@media print';
  var shouldSetHorizontalOrientation = props.stimulus.orientation === LEFT || !props.stimulusOrientationEnabled;
  return {
    stimulus: _objectSpread({}, shouldSetHorizontalOrientation && {
      display: 'flex'
    }),
    leftPanel: _objectSpread(_objectSpread({
      boxSizing: 'border-box',
      maxHeight: '105vh',
      overflow: 'auto',
      borderRight: "".concat(componentTheme.leftPanelBorderWidth, " solid ").concat(componentTheme.leftPanelBorderColor)
    }, shouldSetHorizontalOrientation && {
      width: '50%'
    }), {}, _defineProperty({}, mp, {
      maxHeight: 'none'
    })),
    itemPanel: _objectSpread(_objectSpread(_objectSpread({}, shouldSetHorizontalOrientation && {
      width: '50%'
    }), props.stimulus.isTemporary() && {
      display: 'none'
    }), !props.stimulus.isTemporary() && _defineProperty({
      boxSizing: 'border-box',
      maxHeight: '105vh',
      overflow: 'auto',
      paddingLeft: componentTheme.rightPanelPadding,
      marginLeft: "calc(".concat(componentTheme.rightPanelPadding, " * -1)")
    }, mp, {
      maxHeight: 'none'
    })),
    stimulusWrapper: {
      transform: 'translate3d(0, 0, 0)' /* for drag and drop preview to work */
    },
    dragAndDropHandle: {
      cursor: 'move',
      height: '0',
      zIndex: componentTheme.dragAndDropHandleZIndex,
      backgroundColor: 'transparent',
      border: 'none',
      color: 'inherit',
      fontSize: componentTheme.dragAndDropHandleFontSize,
      margin: componentTheme.dragAndDropHandleMargin,
      marginTop: '0',
      position: 'relative'
    },
    quizEntryWrapper: {
      width: '100%'
    }
  };
};
export default generateStyle;